/* eslint-disable no-param-reassign */
import catchify from 'catchify';

const initialState = () => ({
  accountData: null,
  licensingDeals: [],
  isChipsEnabled: (typeof process.env.ENABLE_CHIPS_FRONT_END === 'undefined')
    || process.env.ENABLE_CHIPS_FRONT_END,
});

export const mutations = {
  setAccountData(state, data) {
    state.accountData = data;
  },
  setLicensingDeals(state, data) {
    state.licensingDeals = data;
  },
};

export const getters = {
  accountData: (state) => state.accountData,
  licensingDeals: (state) => state.licensingDeals,
};

export const actions = {
  // eslint-disable-next-line consistent-return
  async updateAccountData({ commit }) {
    const [error, account] = await catchify(this.$axios.get('/api/users/account-data/'));
    if (error) {
      // eslint-disable-next-line no-console
      console.log('error fetching account data', error);
    } else {
      try {
        commit('setAccountData', account.data);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('error setting account data', err);
      }
    }
  },
};

export { initialState as state };
